import { __assign } from "tslib";
import React, { useEffect, useRef, useState, useContext, Fragment } from 'react';
import { Box, Text, Grid, Flex, Button, Link, VStack, HStack, Divider, Input } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { ProjectContext } from "../ThemeProvider";
import { tableHeadStyles, columnStyles } from "../TableOrder";
import { recordStyle } from "./Summary.styles";
import { CheckBoxLabel } from "../CheckBoxLabel";
import { noop, isEmptyObject, formatNumber } from "../../utils";

var validateFunc = function validateFunc(values) {
  var errors = {};

  if (!values.agree) {
    errors.agree = 'จำเป็นต้องยอมรับเงื่อนไข';
  }

  return errors;
};

export var Summary = function Summary(props) {
  var name = props.name,
      net = props.net,
      description = props.description,
      vatPercent = props.vatPercent,
      vat = props.vat,
      total = props.total,
      withHoldingTaxPercent = props.withHoldingTaxPercent,
      withHoldingTax = props.withHoldingTax,
      address = props.address,
      linkTermOfUse = props.linkTermOfUse,
      linkPrivacy = props.linkPrivacy,
      _a = props.onSubmit,
      onSubmit = _a === void 0 ? noop : _a,
      extraValues = props.extraValues,
      _b = props.validate,
      validate = _b === void 0 ? function () {} : _b,
      _c = props.onErrors,
      onErrors = _c === void 0 ? function () {} : _c,
      isLoading = props.isLoading,
      _d = props.loadingText,
      loadingText = _d === void 0 ? 'กำลังดำเนินการชำระเงิน' : _d,
      _e = props.displayAcceptTerms,
      displayAcceptTerms = _e === void 0 ? true : _e,
      discount = props.discount,
      proRateDiscount = props.proRateDiscount,
      showWHTException = props.showWHTException,
      onUseCoupon = props.onUseCoupon,
      contact = props.contact,
      preVatTotal = props.preVatTotal,
      notice = props.notice,
      additionalItems = props.additionalItems,
      _f = props.submitButtonLabel,
      submitButtonLabel = _f === void 0 ? 'ดำเนินการชำระเงิน' : _f;

  var initialValues = __assign({
    agree: false
  }, extraValues);

  var project = useContext(ProjectContext);

  var _g = useState(initialValues),
      values = _g[0],
      setValues = _g[1];

  var _h = useState({}),
      errors = _h[0],
      setErrors = _h[1];

  var _j = useState(0),
      submitCount = _j[0],
      setSubmitCount = _j[1];

  var couponCodeInputRef = useRef(null);

  var setValue = function setValue(name, value) {
    var _a;

    setValues(__assign(__assign({}, values), (_a = {}, _a[name] = value, _a)));
  };

  useEffect(function () {
    setValues(__assign(__assign({}, values), extraValues && extraValues));
  }, [extraValues]);
  useEffect(function () {
    if (submitCount === 0) return;

    if (isEmptyObject(errors)) {
      onErrors({});
      onSubmit();
      return;
    }

    return onErrors(errors);
  }, [errors, submitCount]);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: "8px"
  }, /*#__PURE__*/React.createElement(VStack, {
    p: "6",
    pb: "2",
    spacing: "13px",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "xl",
    fontWeight: "bold"
  }, "\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D"), onUseCoupon && /*#__PURE__*/React.createElement(HStack, {
    spacing: "16px",
    mb: "16px"
  }, /*#__PURE__*/React.createElement(Input, {
    ref: couponCodeInputRef,
    placeholder: "\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A Referral Code \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14",
    sx: {
      fontSize: 'sm',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre',
      borderRadius: 0
    }
  }), /*#__PURE__*/React.createElement(Button, {
    minWidth: "98px",
    variant: "outline",
    colorScheme: "brand",
    isLoading: isLoading,
    onClick: function onClick() {
      if (!couponCodeInputRef.current) return;
      var code = couponCodeInputRef.current.value;
      onUseCoupon(code);
      couponCodeInputRef.current.value = '';
    },
    fontSize: "sm"
  }, "\u0E43\u0E0A\u0E49\u0E23\u0E2B\u0E31\u0E2A"))), address && /*#__PURE__*/React.createElement(Box, {
    p: "2",
    px: "6"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "strong"
  }, "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35"), /*#__PURE__*/React.createElement(Text, null, address)), /*#__PURE__*/React.createElement(Grid, {
    fontSize: "sm",
    gridTemplateColumns: "1fr minmax(90px, 120px)",
    textAlign: "right",
    pt: "2"
  }, /*#__PURE__*/React.createElement(Text, __assign({
    textAlign: "left",
    pl: "6"
  }, tableHeadStyles, {
    pt: "4"
  }), "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"), /*#__PURE__*/React.createElement(Text, __assign({
    pr: "6"
  }, tableHeadStyles, {
    pt: "4"
  }), "\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21 (\u0E1A\u0E32\u0E17)"), /*#__PURE__*/React.createElement(HStack, {
    sx: __assign(__assign({}, recordStyle), {
      justifyContent: 'space-between'
    })
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "left",
    py: "2"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, name), description && /*#__PURE__*/React.createElement(Text, null, "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14: ", description)), /*#__PURE__*/React.createElement(Text, __assign({
    whiteSpace: "pre"
  }, columnStyles), formatNumber(net))), /*#__PURE__*/React.createElement(VStack, {
    spacing: "2",
    sx: recordStyle
  }, !isEmpty(discount) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Discounts, {
    discounts: discount
  }), /*#__PURE__*/React.createElement(Divider, null)), !isEmpty(additionalItems) && /*#__PURE__*/React.createElement(Fragment, null, additionalItems === null || additionalItems === void 0 ? void 0 : additionalItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement(AdditionalItem, __assign({
      key: index + "-" + item.name
    }, item));
  }), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    sx: {
      justifyContent: 'space-between',
      pt: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "left"
  }, "\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E38\u0E17\u0E18\u0E34\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35 / Pre-VAT"), /*#__PURE__*/React.createElement(Text, {
    whiteSpace: "pre"
  }, formatNumber(preVatTotal))), /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    sx: {
      justifyContent: 'space-between',
      pb: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "left"
  }, "VAT ", vatPercent), /*#__PURE__*/React.createElement(Text, {
    whiteSpace: "pre"
  }, formatNumber(vat)))), withHoldingTaxPercent && withHoldingTax ? /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    justifyContent: "space-between",
    sx: recordStyle
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "left",
    pt: "2",
    pb: "2"
  }, "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2A\u0E34\u0E49\u0E19"), /*#__PURE__*/React.createElement(Text, {
    pt: "2",
    pb: "2",
    whiteSpace: "pre"
  }, formatNumber(preVatTotal + vat))) : null, withHoldingTaxPercent && withHoldingTax ? /*#__PURE__*/React.createElement(VStack, {
    spacing: "1",
    sx: __assign(__assign({}, recordStyle), {
      py: 4
    })
  }, /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "left"
  }, "\u0E20\u0E32\u0E29\u0E35\u0E2B\u0E31\u0E01 \u0E13 \u0E17\u0E35\u0E48\u0E08\u0E48\u0E32\u0E22 ", withHoldingTaxPercent, ' ', "(\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E43\u0E19\u0E19\u0E32\u0E21\u0E19\u0E34\u0E15\u0E34\u0E1A\u0E38\u0E04\u0E04\u0E25)"), /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: 'red.400',
      fontWeight: 'semibold',
      whiteSpace: 'pre'
    }
  }, "- " + formatNumber(withHoldingTax)))) : null, showWHTException ? /*#__PURE__*/React.createElement(VStack, {
    spacing: "1",
    sx: __assign(__assign({}, recordStyle), {
      py: 4
    })
  }, /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "left"
  }, "\u0E20\u0E32\u0E29\u0E35\u0E2B\u0E31\u0E01 \u0E13 \u0E17\u0E35\u0E48\u0E08\u0E48\u0E32\u0E22"), /*#__PURE__*/React.createElement(Text, {
    sx: {
      whiteSpace: 'pre'
    }
  }, '-')), /*#__PURE__*/React.createElement(Text, {
    textAlign: "left",
    fontSize: "xs",
    color: "brand.400"
  }, "\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01 ", /*#__PURE__*/React.createElement(Text, {
    as: "strong"
  }, project.title), ' ', "\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E38\u0E19\u0E08\u0E32\u0E01\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E04\u0E13\u0E30\u0E01\u0E23\u0E23\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E38\u0E19 (BOI) \u0E08\u0E36\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23", ' ', /*#__PURE__*/React.createElement(Text, {
    as: "strong"
  }, "\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E01\u0E32\u0E23\u0E16\u0E39\u0E01\u0E2B\u0E31\u0E01\u0E20\u0E32\u0E29\u0E35 \u0E13 \u0E17\u0E35\u0E48\u0E08\u0E48\u0E32\u0E22"), ' ', "\u0E09\u0E30\u0E19\u0E31\u0E49\u0E19\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E01\u0E32\u0E23\u0E2B\u0E31\u0E01\u0E20\u0E32\u0E29\u0E35 \u0E13 \u0E17\u0E35\u0E48\u0E08\u0E48\u0E32\u0E22\u0E41\u0E15\u0E48\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E43\u0E14")) : null, proRateDiscount && /*#__PURE__*/React.createElement(Box, {
    sx: __assign(__assign({}, recordStyle), {
      py: 2
    })
  }, /*#__PURE__*/React.createElement(Discount, {
    discount: proRateDiscount
  })), /*#__PURE__*/React.createElement(HStack, {
    sx: {
      gridColumn: '1/3',
      justifyContent: 'space-between',
      mx: 6
    }
  }, /*#__PURE__*/React.createElement(Text, {
    sx: {
      textAlign: 'left',
      pt: '2',
      pb: '2',
      fontWeight: 'bold'
    }
  }, "\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21\u0E2A\u0E38\u0E17\u0E18\u0E34"), /*#__PURE__*/React.createElement(Text, {
    sx: {
      pt: '2',
      pb: '2',
      fontSize: 'xl',
      fontWeight: 'bold',
      whiteSpace: 'pre'
    }
  }, formatNumber(total))), notice && /*#__PURE__*/React.createElement(Box, {
    sx: {
      p: '8px 24px 0',
      gridColumn: '1/-1'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'center',
      background: '#f8f8f8',
      border: '1px solid #e8e8e8',
      fontSize: '12px',
      fontWeight: 'bold',
      p: '7px'
    }
  }, notice)), /*#__PURE__*/React.createElement(Grid, {
    gridColumn: "1 / 3",
    textAlign: "left",
    p: "6",
    gap: "4"
  }, displayAcceptTerms && /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CheckBoxLabel, {
    onChange: function onChange(v) {
      setValue('agree', v);
    },
    id: "term-policy-checkbox"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    fontWeight: "medium",
    color: "gray.400"
  }, "\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A", /*#__PURE__*/React.createElement(Link, {
    as: "a",
    href: linkTermOfUse,
    target: "_blank",
    color: "gray.700",
    m: "0 3px"
  }, "\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23"), "\u0E41\u0E25\u0E30", /*#__PURE__*/React.createElement(Link, {
    as: "a",
    href: linkPrivacy,
    target: "_blank",
    color: "gray.700",
    m: "0 3px"
  }, "\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E31\u0E01\u0E29\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25")))), errors.agree && /*#__PURE__*/React.createElement(Text, {
    color: "red.400"
  }, "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02"), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    onClick: function onClick() {
      setSubmitCount(submitCount + 1);

      var errorStates = __assign(__assign({}, displayAcceptTerms && validateFunc(values)), validate && validate(values));

      setErrors(errorStates);
    },
    colorScheme: "brand",
    isLoading: isLoading,
    loadingText: loadingText,
    id: "submit-payment-button",
    mt: "4"
  }, submitButtonLabel)))), contact && /*#__PURE__*/React.createElement(Box, {
    fontSize: "sm",
    pt: "6",
    mx: "6"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "strong"
  }, "\u0E41\u0E08\u0E49\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E2A\u0E2D\u0E1A\u0E16\u0E32\u0E21\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48..."), contact.email && /*#__PURE__*/React.createElement(Text, null, "\u0E2D\u0E35\u0E40\u0E21\u0E25:", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "mailto:" + contact.email
  }, contact.email)), contact.tel && /*#__PURE__*/React.createElement(Text, null, "\u0E42\u0E17\u0E23.:", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "tel:" + contact.tel.replace(/-/g, '')
  }, contact.tel)), contact.facebook && /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "\u0E41\u0E1F\u0E19\u0E40\u0E1E\u0E08:", ' ', /*#__PURE__*/React.createElement(Link, {
    href: contact.facebook,
    isExternal: true
  }, contact.facebook)), /*#__PURE__*/React.createElement("br", null), contact.operatingHour && /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23 ", contact.operatingHour)));
};

var AdditionalItem = function AdditionalItem(_a) {
  var name = _a.name,
      description = _a.description,
      price = _a.price;
  return /*#__PURE__*/React.createElement(HStack, {
    sx: {
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, name), description && /*#__PURE__*/React.createElement(Text, null, "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14: ", description)), /*#__PURE__*/React.createElement(Text, __assign({
    whiteSpace: "pre"
  }, columnStyles), formatNumber(price)));
};

var Discount = function Discount(_a) {
  var discount = _a.discount,
      _b = _a.index,
      index = _b === void 0 ? 0 : _b;
  return /*#__PURE__*/React.createElement(VStack, {
    spacing: "1",
    px: "0",
    border: "none",
    sx: {
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    spacing: "4",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "left"
  }, discount.label, "\xA0", discount.onDelete && /*#__PURE__*/React.createElement(Link, {
    as: "button",
    color: "red.400",
    onClick: function onClick() {
      if (discount.onDelete) {
        return discount.onDelete(index);
      }
    }
  }, "\u0E25\u0E1A")), /*#__PURE__*/React.createElement(Box, {
    color: "red.400",
    fontWeight: "semibold",
    whiteSpace: "pre"
  }, "- ", formatNumber(discount.value))), discount.remark && /*#__PURE__*/React.createElement(Text, {
    textAlign: "left",
    fontSize: "xs",
    color: "gray.400"
  }, discount.remark));
};

var Discounts = function Discounts(_a) {
  var discounts = _a.discounts;
  return /*#__PURE__*/React.createElement(VStack, {
    spacing: "4",
    sx: {
      alignItems: 'stretch',
      py: 2
    }
  }, discounts.map(function (discount, idx) {
    return /*#__PURE__*/React.createElement(Discount, {
      key: idx + "-" + discount.label,
      index: idx,
      discount: discount
    });
  }));
};